import { TypeIcon } from 'core/types';

export const logo: TypeIcon = {
  viewBox: '0 0 52 52',
  path: '<path fill-rule="evenodd" clip-rule="evenodd"  d="M26 47.4783C37.8621 47.4783 47.4783 37.8621 47.4783 26C47.4783 14.1379 37.8621 4.52174 26 4.52174C14.1379 4.52174 4.52174 14.1379 4.52174 26C4.52174 37.8621 14.1379 47.4783 26 47.4783ZM26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z"/> <path d="M33 36H19V15H32.8228V19.2113H23.7342V23.3943H31.9114V27.2382H23.7342V31.7887H33V36Z"/>',
};
